<template>
  <img :src=image>
</template>

<script>
  export default {
    name: "secondBelt",
    props: {
      beddingType: {
        type: String,
        validator: function (value) {
          // The value must match one of these strings
          return ['low', 'high'].indexOf(value) !== -1
        }
      },
      imgURL: String,
      variant:String,
      color:String,
      wideness:String
    }, computed: {
      image: function () {
        return this.imgURL + "Lederriemen/" + this.variant+"-Riemen/" + this.wideness +"/"+ "bottom" +"/"+ ['belt', this.color].join('_')+".png"

      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/secondBelt.vue